module.exports = "https://cdn.littlereply.com/tt/resource/picNewversionPopup@2x.efd4ae4b2f7eec1deba79e5fd27b82f8.png";